/* 
Displays ENS info instead of an Eth address if it exists
*/
import { Text } from "@mantine/core";
import UseENS from "../../hooks/WithENS";
import { useState, useEffect } from "react";
import "./address.css";

export default function EthAddress(props) {
  const [currentName, setCurrentName] = useState(props.address);
  const { getENS } = UseENS();

  const fetchENS = async () => {
    // Display cached value if it's still pretty recent
    let thisAddr = props.address;
    if (props.cachedENS) {
      for (const thisObj of props.cachedENS) {
        if (thisObj.address == thisAddr) {
          const diffMs = Date.now() - thisObj.timestamp;
          const diffHrs = Math.floor((diffMs % 86400000) / 3600000);
          if (thisObj.domain) {
            setCurrentName(thisObj.domain);
          }
          // If this is a recent object, quit so we don't fetch a new value
          if (diffHrs < 4) {
            if (thisAddr != currentName) {
              setCurrentName(thisAddr);
            }
            return;
          }
        }
      }
    }
    const ENSInfo = await getENS(props.address);
    // If we have no ENS info, we might still need to mutate the name if the address changed
    if (!ENSInfo || !ENSInfo.domain) {
      if (thisAddr != currentName) {
        setCurrentName(thisAddr);
      }
      return;
    }
    if (currentName != ENSInfo.domain) {
      setCurrentName(ENSInfo.domain);
    }
  };
  useEffect(() => {
    fetchENS();
  }, [props.address]);

  // Function to select a Transcoder, if it is passed
  const selectTranscoder = async () => {
    if (props.selectTranscoder) {
      props.selectTranscoder(props.address);
    }
  };

  return (
    <Text
      sx={{
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      }}
      onClick={selectTranscoder}
      className={[
        props.selectTranscoder && "hoverAddress",
        props.emphasize && "emphasized",
      ]}
    >
      {props.preamble}
      {currentName}
    </Text>
  );
}
